import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const DETECTION_OPTIONS = {
    order: ['path', 'navigator'],
    lookupFromPathIndex: 0
  };

i18n.use(initReactI18next).use(LanguageDetector).init({
  detection: DETECTION_OPTIONS,
  fallbackLng: 'en',
  supportedLngs: ['en', 'pl', 'de', 'es', 'pt'],
  load: 'languageOnly',
  resources: {
    en: {
      translations: require('./locales/en/translations.json')
    },
    pl: {
      translations: require('./locales/pl/translations.json')
    },
    de: {
      translations: require('./locales/de/translations.json')
    },
    es: {
      translations: require('./locales/es/translations.json')
    },
    pt: {
      translations: require('./locales/pt/translations.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

export default i18n;
